import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecocardiogramas',
  templateUrl: './ecocardiogramas.component.html',
  styleUrls: ['./ecocardiogramas.component.css']
})
export class EcocardiogramasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
